module.exports = __webpack_public_path__ + "static/media/15.011.fcb1333d.jpg";